module.exports = __webpack_public_path__ + "static/media/transactionCompleted2.6a002ab9.svg";